import { render, staticRenderFns } from "./ResultCockroachRoad.vue?vue&type=template&id=0d25e644&"
import script from "./ResultCockroachRoad.vue?vue&type=script&lang=js&"
export * from "./ResultCockroachRoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports